
import React, { useEffect, useState } from 'react';
import Labels from '../../variables/labels';
import Loader from '../loader/loader';
import { ASSETS } from 'assets/images/images.js';

const WelcomeLogo = () => {
  const [showAnimation, setShowAnimation] = useState(false);
  const [isAnimating, setAnimating] = useState(false);
  const [svgMarkup, setSvgMarkup] = useState('');

  // Manage reveal and animation timing once on mount
  useEffect(() => {
    const revealTimer = setTimeout(() => {
      setShowAnimation(true);
      setAnimating(true);
    }, 1500);

    // Stop the animation state slightly after it ends (CSS handles the final state)
    const stopTimer = setTimeout(() => {
      setAnimating(false);
    }, 1500 + 1000); // reveal delay + ~animation duration

    return () => {
      clearTimeout(revealTimer);
      clearTimeout(stopTimer);
    };
  }, []);

  // Load inline SVG to preserve vector crispness and avoid rasterization during transforms
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await fetch(ASSETS.clientLogo, { cache: 'no-store' });
        const txt = await res.text();
        if (!cancelled) setSvgMarkup(txt);
      } catch (e) {
        if (!cancelled) setSvgMarkup('');
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const renderLogo = () => {
    if (!showAnimation) return <div style={{ height: 50 }}></div>;
    if (!svgMarkup) return <Loader />;
    return (
      <div
        className={`welcome-logo ${isAnimating ? 'animate' : ''} welcome-svg`}
        style={{ width: 200, height: 50 }}
        // Intentionally injecting trusted local SVG for crisp vector rendering
        dangerouslySetInnerHTML={{ __html: svgMarkup }}
      />
    );
  };
  return (
    <div className="d-flex w-100 vh-100 align-center justify-content-center flex-column">
      {/* Local styles for animation */}
      <style>
        {`
        .welcome-logo {
          transform-origin: center;
          will-change: transform, opacity;
          display: block;
          opacity: 1;
        }
        .welcome-logo.animate {
          animation: wl-scale-in 900ms ease-out both;
        }
        /* Improve SVG crispness */
        .welcome-svg svg { 
          width: 100%;
          height: 100%;
          shape-rendering: geometricPrecision;
          text-rendering: optimizeLegibility;
          image-rendering: -webkit-optimize-contrast;
          image-rendering: optimizeQuality;
          transform-box: view-box;
        }
        @keyframes wl-scale-in {
          0% { transform: scale(0.94); opacity: 0; }
          60% { transform: scale(1.02); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
        @media (prefers-reduced-motion: reduce) {
          .welcome-logo.animate { animation: none; }
        }
        `}
      </style>
      <div className="w-100 d-flex justify-content-center">
        {renderLogo()}
      </div>
      <div className="w-100 text-center normal-regular-black">
        <p className='m-0 normal-regular-black'>{Labels.liteWelcomeMessage.text1}</p>
        <p className='normal-regular-black'>{Labels.liteWelcomeMessage.text2}</p>
      </div>
    </div>
  );
}
export default WelcomeLogo;